import { inject, provide, ref } from 'vue';
import type { InjectionKey } from 'vue';
import { PinRestoreStep } from '../types/pin.type';
import type { PinRestoreProvider } from '../types/pin.type';

export const PIN_RESTORE_PROVIDER_KEY: InjectionKey<PinRestoreProvider> =
  Symbol('pinRestoreProvider');

const initialPinRestore: PinRestoreProvider = {
  step: ref(PinRestoreStep.PIN),
  currentPin: ref(''),
};

export function usePinRestoreProvider(): PinRestoreProvider {
  const step = ref(PinRestoreStep.PIN);
  const currentPin = ref('');

  return { step, currentPin };
}

export function providePinRestore(): PinRestoreProvider {
  const provider = usePinRestoreProvider();
  provide(PIN_RESTORE_PROVIDER_KEY, provider);
  return provider;
}

/** Devuelve el provider de arriba; sin PinRestore (cambio de PIN del perfil) cae al estado inicial. */
export function injectPinRestore(): PinRestoreProvider {
  return inject(PIN_RESTORE_PROVIDER_KEY, initialPinRestore);
}
